<div class="container-fluid">
    <div class="row">
        <div class="col-sm-12">
            <app-breadcrumb
                [title]="getTitle().module | translate"
                [active_item]="getTitle().subModule | translate"
            ></app-breadcrumb>
            <div class="card">
                <div class="card-body">
                    <div *ngIf="!displayUrlErrorPage">
                        <div class="d-flex justify-content-between mb-3">
                            <div class="d-flex justify-content-between">
                                <app-patrimoine-header
                                    [displayDate]="false"
                                    [displayList]="false"
                                    [count]="listSim"
                                    [total]="pagination?.total"
                                    [legendePluriel]="'Dossier'"
                                    [legendeSingulier]="'Dossier'"
                                >
                                </app-patrimoine-header>
                                <span
                                    class="table-header-wrapper d-flex align-items-center"
                                >
                                    <ng-container
                                        *ngIf="
                                            !isLoadingTitle;
                                            else loadingTitle
                                        "
                                    >
                                        <b>
                                            [<span
                                                class="text-orange fs-4 text-uppercase"
                                                >{{ urlParamTypeDemand }}</span
                                            >] [<span
                                                class="text-orange fs-4"
                                                >{{
                                                    urlParamNumberDemand
                                                }}</span
                                            >]
                                        </b>
                                    </ng-container>
                                    <ng-template #loadingTitle>
                                        <app-spinner-title-details></app-spinner-title-details>
                                    </ng-template>
                                </span>
                            </div>

                            <div>
                                <div>
                                    <p-button
                                        (click)="onGoToBack()"
                                        [label]="'Fermer'"
                                        styleClass="p-button-danger"
                                    >
                                    </p-button>
                                </div>
                            </div>
                        </div>

                        <div>
                            <div class="container-box">
                                <app-taches-a-traiter-box
                                    *ngFor="let box of statistiquesBox"
                                    class="col-md"
                                    [cardBgColor]="box?.['cardBgColor']"
                                    [cardBorderColor]="box?.['cardBorderColor'] ?? '#FFF'"
                                    [legend]="box?.['legend']"
                                    [count]="box?.['count']"
                                    [legendColor]="box?.['legendColor'] ?? '#FFF'"
                                    [countColor]="box?.['countColor'] ?? '#FFF'"
                                    [taux]="box?.['taux']"
                                >
                                </app-taches-a-traiter-box>
                            </div>

                            <app-filter-sim-demand
                                (filter)="filter($event)"
                                [listEtapeLigne]="listEtapeLigne"
                                [listEtatLigne]="listEtatLigne"
                            >
                            </app-filter-sim-demand>

                            <hr />

                            <app-table-sim-demand
                                [pagination]="pagination"
                                [listSim]="listSim"
                                [urlParamTypeDemand]="urlParamTypeDemand"
                            >
                            </app-table-sim-demand>

                            <app-pargination
                                [pargination]="pagination"
                                (pageChange)="onPageChange($event)"
                            >
                            </app-pargination>
                        </div>
                    </div>

                    <div *ngIf="displayUrlErrorPage">
                        <div>
                            <div class="d-flex justify-content-end">
                                <p-button
                                    label="Fermer"
                                    styleClass="p-button-danger"
                                    (click)="onGoToBack()"
                                ></p-button>
                            </div>
                        </div>
                        <div
                            class="d-flex justify-content-center align-items-center text-danger"
                        >
                            {{ 'NO_DATA_FOUND' | translate }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
